<template>
    <v-dialog v-model="model" max-width="600px" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-card>
            <div class="pl-4 pr-3 py-3 primary">
                <div class="d-flex align-center justify-space-between">
                    <div>
                        <v-layout align-center>
                            <v-icon size="12px" color="white" class="mr-2">fa-pen fa-fw</v-icon> 
                            <div class="white--text font-weight-medium caption">UPLOAD FILE</div> 
                        </v-layout>
                    </div>
                    <div>
                        <v-btn small text fab @click="$emit('cancel')" class="my-0">
                            <v-icon small color="white">fa-times</v-icon> 
                        </v-btn>
                    </div>
                </div>
            </div>

            <v-card-text class="pt-8">
                <div class="px-4 black--text body-1 text-center">
                    <v-file-input 
                        prepend-icon="fa-paperclip accent--text" 
                        label="Select the file" 
                        outlined dense
                        @change="selectedFile" 
                        show-size>
                    </v-file-input>
                </div>
            </v-card-text>

            <div class="d-flex justify-end align-center px-4 pb-4" :class="(sending) ? 'pa-1' : 'pa-4'">
                <v-btn text large class="info--text text--darken-1" @click="$emit('cancel')" v-if="!sending">Cancel</v-btn>
                <v-btn text large class="accent" @click="validate" v-if="!sending">Save</v-btn>
                <SendingLoader v-if="sending" />
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import Sign from '@/firebase/sign'
import Work from '@/firebase/work'
import Validation from '@/services/validation'

export default {
    data: () => ({
        sending: false,
        file: null
    }),
    props: ['model', 'item'],
    computed: {
        progress() {
            return this.$store.getters.fileProgress;
        },
        uploading() {
            return this.$store.getters.fileUploading;
        },
        uploaded() {
            return this.$store.getters.fileUploaded;
        }
    },
    watch: {
        uploaded(val) {
            if (val === true) {
                this.$emit('close');
                Sign.reInitUser(this.user.uid);
            }
        },
        model(val) {
            if (val == false) {
                this.sending = false;
            }
        }
    },
    methods: {
        openFile() {
            this.$refs.fileInput.click();
        }, 
        selectedFile(f) {
            this.file = f;
        },
        validate() {
            if (this.file == null) {
                this.$store.dispatch('setSnack', {kind:'error', text:'File is missing.'});
                return;
            }

            this.save();
        },
        save() {
            this.sending = true;    
            Work.uploadPDA(this.item.uid, 'pda', this.file);
        }
    }
}
</script>

